import React from 'react';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { PlanSummaryPageTemplate } from './planSummaryPage';

export const PlanSummaryPageContainerTemplate = () => {
  const { pageContentResource, isPageContentLoading } = usePageContentContext();
  useBoneBackgroundColor();
  // Need this data container so that any time someone refreshes the entire page content collection, the relationships this page fetches are also re-fetched
  return (
    <FullScreenDataContainer
      loading={isPageContentLoading || !pageContentResource}
      component={PlanSummaryPageTemplate}
      componentProps={{ resource: pageContentResource }}
    />
  );
};
